export const cousntryCodesArr = [
    { name: "US", code: "+1" },
    { name: "UK", code: "+44" },
    { name: "Can", code: "+1" },
    { name: "Aust", code: "+61" },
    { name: "Ind", code: "+91" },
    { name: "Ger", code: "+49" },
    { name: "Fra", code: "+33" },
    { name: "Ital", code: "+39" },
    { name: "Spa", code: "+34" },
    { name: "Bra", code: "+55" },
    { name: "Mex", code: "+52" },
    { name: "Jap", code: "+81" },
    { name: "Chn", code: "+86" },
    { name: "Rus", code: "+7" },
    { name: "SA", code: "+27" },
    { name: "NZ", code: "+64" },
    { name: "SG", code: "+65" },
    { name: "SK", code: "+82" },
    { name: "Swe", code: "+46" },
    { name: "Neth", code: "+31" },
    { name: "Switz", code: "+41" },
    { name: "Nor", code: "+47" },
    { name: "Den", code: "+45" },
    { name: "Fin", code: "+358" },
    { name: "Bel", code: "+32" },
    { name: "Aus", code: "+43" },
    { name: "Por", code: "+351" },
    { name: "Gre", code: "+30" },
    { name: "Ire", code: "+353" },
    { name: "Isr", code: "+972" },
    { name: "SA", code: "+966" },
    { name: "UAE", code: "+971" },
    { name: "Tur", code: "+90" },
    { name: "Arg", code: "+54" },
    { name: "Chi", code: "+56" },
    { name: "Col", code: "+57" },
    { name: "Per", code: "+51" },
    { name: "Ven", code: "+58" },
];